<template>
  <div class="burger-closed-wrap" @click="openSidebar(!sidebarOpen)">
    <Icon type="menu" :color="isColoredHeader ? 'oncolor' : 'primary'" size="20" />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'SidebarOpener',
    components: { Icon },
    mounted() {
      this.$nextTick(() => {
        this.onResize();
        window.addEventListener('resize', this.onResize);
      });
    },
    computed: {
      ...mapState({
        sidebarOpen: (state) => state.global.sidebarOpen,
      }),
      isColoredHeader() {
        return (
          this.$route.path.includes('projects/') || this.$route.path.includes('incoming_tender/')
        );
      },
      width() {
        return window.innerWidth;
      },
    },
    methods: {
      ...mapActions({
        openSidebar: 'global/openSidebar',
      }),
      onResize() {
        if (window.innerWidth <= 1100 && this.sidebarOpen) {
          this.openSidebar(false);
        }
      },
    },
  };
</script>
<style scoped>
  .burger-closed-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
</style>
